// AWS Amplify Configuration
// These values should be replaced with actual values from CDK deployment outputs

const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USER_POOL_ID || 'eu-west-1_XXXXXXXXX',
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID || 'XXXXXXXXXXXXXXXXXXXXXXXXXX',
      region: process.env.REACT_APP_AWS_REGION || 'eu-west-1',
      loginWith: {
        email: true,
        username: true,
      },
    },
  },
  API: {
    REST: {
      HoneymoonRegistryAPI: {
        endpoint: process.env.REACT_APP_API_ENDPOINT || 'https://xxxxxxxxxx.execute-api.eu-west-1.amazonaws.com/prod',
        region: process.env.REACT_APP_AWS_REGION || 'eu-west-1',
      },
    },
  },
};

export default awsConfig;
